'use client';

import { DiscussionEmbed } from 'disqus-react';
import { usePathname } from 'next/navigation';

interface DisqusCommentsProps {
  identifier?: string;
  title: string;
}

export function DisqusComments({ identifier, title }: DisqusCommentsProps) {
  const pathname = usePathname();
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const url = `${origin}${pathname}`;

  return (
    <DiscussionEmbed
      shortname="alialhaddad"
      config={{ url, identifier: identifier ?? title, title }}
    />
  );
}
